import { styled } from '@mui/material/styles';

const StyFilterValue = styled('span', {
    name: 'StyFilterValue',
})({
    marginRight: '0.1cm',
    backgroundColor: '#D6E3FF',
});

export type FilterValuesProps = {
    singleFilter: SentenceFilterT;
};

export default StyFilterValue;
